import App from '../app'
import Vue from 'vue'

/* eslint-disable no-new */
new Vue({
  extends: App,
  methods: {

  }
})
